module.exports = __webpack_public_path__ + "static/media/facebook.fdc02ea7.svg";